import React, {useContext, useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {CFormInput, CFormLabel, CFormSelect, CFormTextarea, CModalTitle} from "@coreui/react";
import Button from "react-bootstrap/Button";
import {StateContext} from "../context/StateProvider";
import {DateTimePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {TextField} from "@mui/material";
import dayjs from "dayjs";
import ContenedorModel from '../../models/Contenedor';
import SelectorArchivos from "../comun/selectorArchivos";
import HostService from "../../services/host.service";
import {RUTAS} from "../../config/constants";
import {cilFile, cilX} from "@coreui/icons";
import CIcon from "@coreui/icons-react";

const Contenedor = ({show, handleClose, handleConfirm, contenedorInicial, handleDeleteDocumento}) => {

    const {state, updateState} = useContext(StateContext);
    const [error, setError] = useState('');
    const [formData, setFormData] = useState(
        ContenedorModel.from({ ejercicio: state.year }).toObject()
    );
    const [almacenSeleccionado, setAlmacenSeleccionado] = useState('');
    const [imagenes, setImagenes] = useState([]);


    useEffect(() => {
        if (show) {
            const contenedor = ContenedorModel.from({
                ...contenedorInicial,
                ejercicio: contenedorInicial?.ejercicio ?? state.year
            });

            setFormData(contenedor.toObject());
            setAlmacenSeleccionado(contenedor.almacen);
        }
    }, [contenedorInicial, show]);

    const handleSave = () => {

        const cleanedData = Object.fromEntries(
            Object.entries(formData).filter(([_, value]) => value !== null && value !== '')
        );

        if (!cleanedData.contenedor || !cleanedData.almacen) {
            setError('Los campos contenedor y almacén son obligatorios.');
            return;
        }

        const datos = {
            ...cleanedData,
            id: contenedorInicial?.id ?? null,
            documentos: imagenes.length > 0 ? imagenes : []
        };

        const contenedor = ContenedorModel.from(datos);

        setError('');
        setImagenes([]);
        handleConfirm(contenedor.toObject());
        setAlmacenSeleccionado('');
    };

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prev) => ({...prev, [name]: value}));
    };

    const handleDateChange = (value, field) => {
        setFormData((prev) => ({...prev, [field]: value ? new Date(value) : null}));
    };

    const handleEliminarDocumento = (idContenedor,idDocumento) => {
        handleDeleteDocumento(idContenedor,idDocumento);
    }

    return (

        <Modal id='modal-contenedor' size="lg" show={show} onHide={() => handleClose()} centered>
            <Modal.Header closeButton>
                <CModalTitle> {contenedorInicial?.id ? 'Editar contenedor' : 'Nuevo contenedor'}</CModalTitle>
            </Modal.Header>
            <Modal.Body>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {error && <div style={{color: 'red'}}>{error}</div>}

                    <div className="mb-3">
                        <CFormLabel>Contenedor</CFormLabel>
                        <CFormInput
                            name="contenedor"
                            value={formData.contenedor}
                            onChange={handleChange}
                            placeholder="Código del contenedor"
                        />
                    </div>

                    <div className="mb-3">
                        <CFormLabel>Concepto</CFormLabel>
                        <CFormInput
                            name="concepto"
                            value={formData.concepto}
                            onChange={handleChange}
                            placeholder="Concepto"
                        />
                    </div>

                    <div className="mb-3">
                        <CFormLabel>Preparador</CFormLabel>
                        <CFormInput
                            name="preparador"
                            value={formData.preparador}
                            onChange={handleChange}
                            placeholder="Preparador"
                        />
                    </div>

                    <div className="mb-3">
                        <CFormLabel>Fecha de llegada muelle</CFormLabel>
                        <DateTimePicker
                            value={formData.fecha_llegada_muelle ? dayjs(formData.fecha_llegada_muelle) : null}
                            onChange={(value) => handleDateChange(value, 'fecha_llegada_muelle')}
                            inputFormat="DD/MM/YYYY HH:mm"
                            ampm={false}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </div>

                    <div className="mb-3">
                        <CFormLabel>Naviera</CFormLabel>
                        <CFormInput
                            name="naviera"
                            value={formData.naviera}
                            onChange={handleChange}
                            placeholder="Naviera"
                        />
                    </div>

                    <div className="mb-3">
                        <CFormLabel>Fecha de llegada</CFormLabel>
                        <DateTimePicker
                            value={formData.fecha_llegada ? dayjs(formData.fecha_llegada) : null}
                            onChange={(value) => handleDateChange(value, 'fecha_llegada')}
                            inputFormat="DD/MM/YYYY HH:mm"
                            ampm={false}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </div>

                    <div className="mb-3">
                        <CFormLabel>Fecha de salida</CFormLabel>
                        <DateTimePicker
                            value={formData.fecha_salida ? dayjs(formData.fecha_salida) : null}
                            onChange={(value) => handleDateChange(value, 'fecha_salida')}
                            inputFormat="DD/MM/YYYY HH:mm"
                            ampm={false}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </div>

                    <div className="mb-3">
                        <CFormLabel>Fecha de aviso</CFormLabel>
                        <DateTimePicker
                            value={formData.fecha_aviso ? dayjs(formData.fecha_aviso) : null}
                            onChange={(value) => handleDateChange(value, 'fecha_aviso')}
                            inputFormat="DD/MM/YYYY HH:mm"
                            ampm={false}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </div>

                    <div className="mb-3 form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="es_exportacion"
                            checked={formData.es_exportacion}
                            onChange={(e) => setFormData(prev => ({ ...prev, es_exportacion: e.target.checked }))}
                        />
                        <label className="form-check-label" htmlFor="es_exportacion">
                            ¿Es exportación?
                        </label>
                    </div>

                    <div className="mb-3">
                        <CFormLabel>Almacén</CFormLabel>
                        <CFormSelect
                            value={almacenSeleccionado}
                            onChange={(e) => {
                                const value = e.target.value;
                                setAlmacenSeleccionado(value);
                                setFormData((prev) => ({...prev, almacen: value}));
                            }}
                        >
                            <option value="">Seleccione un almacén</option>
                            <option value="PENDIENTE">PENDIENTE</option>
                            {state.almacenes.map((a) => (
                                <option key={a.NOMBRE} value={a.NOMBRE}>
                                    {a.NOMBRE}
                                </option>
                            ))}
                        </CFormSelect>
                    </div>

                    <div className="mb-3">
                        <CFormLabel>Comentarios</CFormLabel>
                        <CFormTextarea
                            name="comentarios"
                            value={formData.comentarios}
                            onChange={handleChange}
                            placeholder="Comentarios"
                            style={{ minHeight: '120px' }}
                        />
                    </div>
                </LocalizationProvider>
                {formData.documentos.length > 0 && (
                    <div className="mb-3">
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            {formData.documentos.length > 0 && (
                                <div className="mb-3">
                                    <CFormLabel>Documentos:</CFormLabel>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                        {formData.documentos.map((doc, index) => {
                                            const mime = doc.mime_type || '';
                                            const isImage = mime.startsWith('image/');

                                            return (
                                                <div key={index}>
                                                    <a
                                                        href={`${HostService.getHost()}${RUTAS.IMAGENES}/${doc.ruta}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        download
                                                    >
                                                        <CIcon icon={cilFile} size="lg" />
                                                        {doc.nombre}
                                                    </a>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleEliminarDocumento(formData.id, doc.id)}
                                                        className="delete-file"
                                                        title="Eliminar documento"
                                                    >
                                                        <CIcon icon={cilX} size="lg" />
                                                    </button>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                <SelectorArchivos accept={"*"} inputContent={"Arrastra un fichero o haz clic"} inputWithFilesContent={"Añadir ficheros"} acumular={true} onFilesChange={setImagenes}/>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleSave}>
                    Guardar
                </Button>
                <Button variant="secondary" onClick={() => handleClose()}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );

}

export default Contenedor;